module.exports = __webpack_public_path__ + "img/svg61.527dfe0d.svg";